import React from "react";
import { GaugeSVGBaseProps } from "../gauge-types";

export const GaugeSVGBase: React.FC<GaugeSVGBaseProps> = (props) => {
  return <svg {...props}></svg>;
};
